import { Upload } from 'antd';
import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** 保存搜索 列表首页的搜索条件 */
    public recordSearch: any = undefined;
    /** 表单类型 */
    public documentType: string = '';
    /** 文件id */
    public documentUUID: string = '';
    /** 初始化  订单 格式 */
    public linesKey: number[] = [];
    /** 日期格式 */
    public dateFormat: string = 'YYYY-MM-DD HH:mm';
    public timeFormat: string = 'HH:mm';
    /** 需要发送的公司id(以便获取对应单据规则) */
    public connectionCompanyId: string = undefined;
    /** 行自定义 Col span样式 */
    public lineExtraColSpan: number = 8;
    /** 单据规则 */
    public rules: any = {
        Lines: {
            Extra: {
            },
        },
        Extra: {
        },
    };
    /** 订单 */
    public orderForm: {
        DocumentType: string;
        ID: string;
        IssueDate: number;
        DocumentCurrencyCode: string;
        BuyerCustomerParty: {
            ID: string;
            Name: string;
        };
        BuyerContact: {
            ID: string;
            Name: string;
        };
        SellerSupplierParty: {
            ID: string;
            Name: string;
        };
        SellerContact: {
            ID: string;
            Name: string;
        };
        RequestedDeliveryPeriod: {
            StartDate: number;
            EndDate: number;
        };
        Lines: {
            Number: number;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            Quantity: number;
            LineExtensionAmount: string;
            DocumentReference: string;
            LineReference: string;
            Description: string;
            UnitCode: string;
            Price: string;
            BaseQuantity: number;
            TaxRate: number;
        }[];
        Total: number;
        PaymentMeans: string;
        Note: string;
        DeliveryAddress: {
            Country: string;
            CountrySubentity: string;
            CityName: string;
            AddressLine: string;
        };
        DeliveryContact: {
            Name: string;
            Phone: string;
        };
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
            DocumentType: '',
            ID: '',
            IssueDate: undefined,
            DocumentCurrencyCode: '',
            BuyerCustomerParty: {
                ID: '',
                Name: '',
            },
            BuyerContact: {
                ID: '',
                Name: '',
            },
            SellerSupplierParty: {
                ID: '',
                Name: '',
            },
            SellerContact: {
                ID: '',
                Name: '',
            },
            RequestedDeliveryPeriod: {
                StartDate: undefined,
                EndDate: undefined,
            },
            Lines: [],
            Total:0,
            PaymentMeans: '',
            Note: '',
            DeliveryAddress: {
                Country: undefined,
                CountrySubentity: undefined,
                CityName: undefined,
                AddressLine: '',
            },
            DeliveryContact: {
                Name: '',
                Phone: '',
            },
            Attachments: [],
        };
    /** 计划单据(要货计划/预测计划) */
    public forecastForm: {
        DocumentReference: string;
        LineReference: string;
        DocumentType: string;
        ForecastPurposeCode: string;
        ID: string;
        IssueDate: number;
        DocumentCurrencyCode: string;
        SenderParty: {
            ID: string;
            Name: string;
        };
        SenderContact: {
            ID: string;
            Name: string;
        };
        ReceiverParty: {
            ID: string;
            Name: string;
        };
        ReceiverContact: {
            ID: string;
            Name: string;
        };
        ForecastPeriod: {
            StartDate: number;
            EndDate: number;
        },
        Lines: {
            Number: number;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            Description: string;
            UnitCode: string;
            Quantity: number;
            ReceiveAddress: string;
            ReceiveFactory: string; 
            ApprovalNo: string; 
            ForecastStageQuantity: {
                Date: string;
                Quantity: number;
            }[];
        }[];
        Note: string;
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
        DocumentReference: undefined,
        LineReference: undefined,
        DocumentType: '',
        ForecastPurposeCode: undefined,
        ID: undefined,
        IssueDate: undefined,
        DocumentCurrencyCode: undefined,
        SenderParty: {
            ID: undefined,
            Name: undefined,
        },
        SenderContact: {
            ID: undefined,
            Name: undefined,
        },
        ReceiverParty: {
            ID: undefined,
            Name: undefined,
        },
        ReceiverContact: {
            ID: undefined,
            Name: undefined,
        },
        ForecastPeriod: {
            StartDate: undefined,
            EndDate: undefined,
        },
        Lines: [],
        Note: undefined,
        Attachments: [],
    };
    /**
     *  发货单
     */
    public despatchAdviceForm: {
        DocumentType: string;
        ID: string;
        IssueDate: number;
        DespatchSupplierParty: {
            ID: string; 
            Name: string;
        };
        DespatchSupplierContact: {
            ID: string;
            Name: string;
        };
        DeliveryCustomerParty: {
            ID: string;
            Name: string;
        };
        DeliveryCustomerContact: {
            ID: string;
            Name: string;
        };
        Lines: {
            ReceiveAddress: string;
            ReceiveFactory: string;
            Number: string;
            DocumentReference: string;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            LineReference: string;
            UnitCode: string;
            OrderedQuantity: number; 
            DeliveredQuantity: number;
            Description: string;
            DocumentReference2: string;
            LineReference2: string;
        }[];
        DeliveryAddress: {
            Country: string;
            CountrySubentity: string;
            CityName: string;
            AddressLine: string;
        };
        DeliveryContact: {
            Name: string;
            Phone: string;
        },
        DeliveryDate: number;
        TransportModeCode: string;
        TransportMeansTrackingID: string;
        PerformingCarrierPartyContact: {
            ID: string;
            Name: string;
            Phone: string;
        };
        CarrierParty: {
            ID: string;
            Name: string;
        };
        Note: string;
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
        DocumentType: undefined,
        ID: undefined,
        IssueDate: undefined,
        DespatchSupplierParty: {
            ID: undefined,
            Name: undefined,
        },
        DespatchSupplierContact: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryCustomerParty: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryCustomerContact: {
            ID: undefined,
            Name: undefined,
        },
        Lines: [],
        DeliveryAddress: {
            Country: undefined,
            CountrySubentity: undefined,
            CityName: undefined,
            AddressLine: undefined,
        },
        DeliveryContact: {
            Name: undefined,
            Phone: undefined,
        },
        DeliveryDate: undefined,
        TransportModeCode: undefined,
        TransportMeansTrackingID: undefined,
        PerformingCarrierPartyContact: {
            ID: undefined,
            Name: undefined,
            Phone: undefined,
        },
        CarrierParty: {
            ID: undefined,
            Name: undefined,
        },
        Note: undefined,
        Attachments:[],
    };
    /**
     * 收货单
     */
    public receiptAdviceForm: {
        DocumentType: string;
        ReceiptAdviceTypeCode: string;
        ID: string;
        IssueDate: number;
        PostingDate: number;
        DespatchSupplierParty: {
            ID: string;
            Name: string;
        };
        DespatchSupplierContact: {
            ID: string;
            Name: string;
        };
        DeliveryCustomerParty: {
            ID: string;
            Name: string;
        };
        DeliveryCustomerContact: {
            ID: string;
            Name: string;
        };
        DeliveryDate: string;
        TransportModeCode: string;
        TransportMeansTrackingID: string;
        PerformingCarrierPartyContact: {
            ID: string;
            Name: string;
        };
        CarrierParty: {
            ID: string;
            Name: string;
        };
        DeliveryNote: string;
        Lines: {
            LineID: string;
            DocumentReference: string;
            LineReference: string;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            UnitCode: string;
            DeliveredQuantity:number;
            ReceivedQuantity: number;
            Description: string;
        }[];
        ActualDespatchDate: number;
        DespatchAddressLine: string;
        Note: string;
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
        DocumentType: undefined,
        PostingDate: undefined,
        ReceiptAdviceTypeCode: null,
        ID: undefined,
        IssueDate: undefined,
        DespatchSupplierParty: {
            ID: undefined,
            Name: undefined,
        },
        DespatchSupplierContact: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryCustomerParty: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryCustomerContact: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryDate: undefined,
        TransportModeCode: undefined,
        TransportMeansTrackingID: undefined,
        PerformingCarrierPartyContact: {
            ID: undefined,
            Name: undefined,
        },
        CarrierParty: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryNote: undefined,
        Lines: [],
        ActualDespatchDate: undefined,
        DespatchAddressLine: undefined,
        Note: undefined,
        Attachments: [],
    };
    /**
     * 入库单
     */
    public stockInNoticeForm: {
        DocumentType: string;
        ID: string;
        IssueDate: number;
        PostingDate: number;
        BuyerCustomerParty: {
            ID: string;
            Name: string;
        };
        BuyerContact: {
            ID: string;
            Name: string;
        };
        SellerSupplierParty: {
            ID: string;
            Name: string;
        };
        SellerContact: {
            ID: string;
            Name: string;
        };
        PickupPeriod: {
            StartDate: number;
            EndDate: number;
        };
        Lines: {
            LineID: string;
            DocumentReference: string;
            LineReference: string;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            UnitCode: string;
            ReceivedQuantity: string;
            StockInQuantity: string;
            Description: string;
        }[];
        Note: string;                                  
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
        DocumentType: undefined,
        ID: undefined,
        IssueDate: undefined,
        PostingDate: undefined,
        BuyerCustomerParty: {
            ID: undefined,
            Name: undefined,
        },
        BuyerContact: {
            ID: undefined,
            Name: undefined,
        },
        SellerSupplierParty: {
            ID: undefined,
            Name: undefined,
        },
        SellerContact: {
            ID: undefined,
            Name: undefined,
        },
        PickupPeriod: {
            StartDate: undefined,
            EndDate: undefined,
        },
        Lines: [],
        Note: undefined,
        Attachments: [],
    };
    /** 合同 */
    public ContractForm: {
        DocumentType: string;
        ID: string;
        IssueDate: number;
        DocumentCurrencyCode: string;
        BuyerCustomerParty: {
            ID: string;
            Name: string;
        };
        BuyerContact: {
            ID: string;
            Name: string;
        };
        SellerSupplierParty: {
            ID: string;
            Name: string;
        };
        SellerContact: {
            ID: string;
            Name: string;
        };
        ValidityPeriod: {
            StartDate: number;
            EndDate: number;
        };
        Lines: {
            Number: number;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            Quantity: number;
            LineExtensionAmount: string;
            DocumentReference: string;
            LineReference: string;
            Description: string;
            UnitCode: string;
            Price: string;
            BaseQuantity: number;
            TaxRate: number;
        }[];
        Total: number;
        Note: string;
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
            DocumentType: '',
            ID: '',
            IssueDate: undefined,
            DocumentCurrencyCode: '',
            BuyerCustomerParty: {
                ID: '',
                Name: '',
            },
            BuyerContact: {
                ID: '',
                Name: '',
            },
            SellerSupplierParty: {
                ID: '',
                Name: '',
            },
            SellerContact: {
                ID: '',
                Name: '',
            },
            ValidityPeriod: {
                StartDate: undefined,
                EndDate: undefined,
            },
            Lines: [],
            Total: 0,
            Note: '',
            Attachments: [],
        };
    /** 合计 */
    public priceTotal: number = 0;
    /** 国家 省市 城市地区 */
    public countryList: {
        code: string;
        name: string;
    }[] = [];
    public provinceList: {
        code: string;
        countryCode: string;
        name: string;
    }[] = [];
    public cityList: {
        code: string;
        name: string;
        stateCode: string;
    }[] = [];
    /** 上传的文件列表 */
    public uploadList: any[] = [];

    /** formList */
    public formList: any[] = [];
    /** 错误信息展示 */
    public messageInfos: Map<string,string> = new Map<string,string>();
    /** 需要验证的字段 */
    public validateKeys: any = {};
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/Modules.State.ts